const state = {
  token: '',
  datosPerfil: {}
}

export default state
